module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Text copyright © 2013 by "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Ray Lampe.")]), _c('br'), _vm._v("Photographs copyright © 2013 by "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Jody Horton.")]), _c('br'), _vm._v("Photographs on pages 15 and 16 courtesy of National Pork Board."), _c('br'), _vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-2980-8")]), _vm._v(" "), _c('p', [_vm._v("The Library of Congress has previously cataloged this title under ISBN 978-1-4521-1367-8")]), _vm._v(" "), _c('p', [_vm._v("Designed by "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Vanessa Dina")]), _c('br'), _vm._v("Prop and food styling by "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Kate LeSueur")]), _c('br'), _vm._v("Cooking by "), _c('span', {
    staticClass: "font"
  }, [_vm._v("Angela Howe")]), _c('br'), _vm._v("Typesetting by "), _c('span', {
    staticClass: "font"
  }, [_vm._v("DC Type")])]), _vm._v(" "), _c('p', [_vm._v("Big Green Egg is a registered trademark of Big Green Egg. Cheez Whiz is a registered trademark of Kraft Foods Holdings Inc. Craisins is a registered trademark of Ocean Spray Cranberries Inc. Frank’s Red Hot Sauce is a registered trademark of Reckitt Benckiser. Homer Simpson is a registered trademark of 20th Century Fox Film Corporation. Morton’s Tender Quick is a registered trademark of Morton International Inc. Pendery’s is a registered trademark of Pendery’s Inc. Sugar In The Raw is a registered trademark of Cumberland Packing Co. Superfast Thermapen is a registered trademark of ThermoWorks. Tater Tots is a registered trademark of Ore-Ida.")]), _vm._v(" "), _c('p', [_vm._v("For more information about pork, visit"), _c('br'), _c('a', {
    attrs: {
      "href": "http://PorkBeInspired.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("PorkBeInspired.com")])])]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, California 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("www.chroniclebooks.com")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0005-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aea04c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05copyright.vue
// module id = 69
// module chunks = 0